export const appToDo = "LtTHo";
export default {appToDo};